/* eslint-disable */
import { Divider, Grid, useMediaQuery } from "@mui/material";
import Euler from "assets/euler.png";
import VideoThumnail from "assets/hiload-segment-tumbnail.webp";
import { lazy, Suspense, useEffect, useRef, useState } from "react";

import Enquire from "Pages/Enquire/Enquire";
import Testimonials from "Pages/Landing/components/Testimonials/Testimonials";
import { apiClient } from "api/apiClient";
import { Shimmer } from "react-shimmer";
import VideoSection from "./components/VideoSection/VideoSection";

import { useLanguage } from "LanguageContext";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  fetchCities,
  fetchFaqs,
  fetchFeatureImages,
  fetchLocations,
  fetchProducts,
  fetchStates,
  fetchVideo,
} from "store/thunks";
import { COLORS } from "theme";
import { downloadBroucher, sortData } from "utils";
import BlogSection from "./components/BlogSection/BlogSection";
import BottomContent from "./components/BottomContent/bottom_content";
import ContactSection from "./components/ContactSection/ContactSection";
import CustomerSection from "./components/CustomerSection/CustomerSection";
import InsightsComponent from "./components/Insights/Insights";
import SavingSection from "./components/SavingSection/SavingSection";
import SavingsCalculator from "./components/SavingsCalculator/SavingsCalculator";
import DetailFeatureSection from "./components/featureSection/featureSection";

const Hero = lazy(() => import("Pages/StormEv/Hero/Hero"));

const Landing = () => {
  const dispatch = useDispatch();
  const small = useMediaQuery("(max-width: 768px)");
  const medium = useMediaQuery("(max-width: 1024px)");

  const [isEnquire, setIsEnquire] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const videoRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState(null);

  const [homeSliders, setHomeSliders] = useState([]);
  const [imageSliders, setImageSliders] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [specifications, setSpecifications] = useState({});
  const [icons, setIcons] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsInfo, setTestimonialsInfo] = useState([]);

  const [launchSider, setLaunchSider] = useState([]);
  const { selectedLanguage } = useLanguage();
  const [isLng, setIsLng] = useState(false);
  const { t } = useTranslation();
  const [blogs, setBlogs] = useState([]);
  const [bankData, setBankData] = useState([]);
  const [featureData, setFeatureData] = useState([]);
  const [savingData, setSavingData] = useState([]);
  const [savingTitle, setSavingTitle] = useState([]);
  const [ourBlogTitle, setOurBlogTitle] = useState([]);
  const [insightTitle, setInsightTitle] = useState([]);

  const [productData, setProductData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    // dispatch(fetchBanners());
    dispatch(fetchFaqs());
    // dispatch(fetchTrucks());
    dispatch(fetchVideo());

    dispatch(fetchFeatureImages(selectedLanguage));

    // dispatch(fetchComparisonData());
    dispatch(fetchProducts());
    dispatch(fetchCities());
    dispatch(fetchStates());
    dispatch(fetchLocations());
    apiClient.getHomeSlider().then((res) => {
      setHomeSliders(sortData(res?.data));
    });

    apiClient.getIcons().then((res) => {
      setIcons(res?.data);
    });

    apiClient.getLaunchSider().then((res) => {
      setLaunchSider(res?.data);
    });

    apiClient.getHeroSectionBanner(selectedLanguage).then((res) => {
      setBannerData(res?.data);
    });

    apiClient.getSpecifications().then((res) => {
      setSpecifications(res?.data);
    });
    apiClient.getTestimonialsLR(selectedLanguage).then((res) => {
      setTestimonials(res?.data);
    });
    apiClient.getTestimonialsInfo(selectedLanguage).then((res) => {
      setTestimonialsInfo(res?.data);
    });
    setTimeout(() => {
      setIsEnquire(true);
    }, 1000);
    apiClient.getImageSliderHome().then((res) => {
      setImageSliders(sortData(res?.data));
    });
    if (!sessionStorage.getItem("alertShown")) {
      setTimeout(() => {
        setIsLng(true);
      }, 1000);
      sessionStorage.setItem("alertShown", "true");
    }
  }, []);
  useEffect(() => {
    apiClient.getOurPage().then((res) => {
      setBlogs(res?.data);
    });
    apiClient.getBlogTitle().then((res) => {
      setOurBlogTitle(res?.data);
    });
    apiClient.getBankOffer().then((res) => {
      setBankData(res?.data);
    });
    apiClient.getFeatureDetails().then((res) => {
      setFeatureData(res?.data);
    });
    apiClient.getSavingSection().then((res) => {
      setSavingData(res?.data);
    });
    apiClient.getSavingSectionTitle().then((res) => {
      setSavingTitle(res?.data);
    });

    apiClient.getOurProduct().then((res) => {
      setProductData(res?.data);
    });

    apiClient.getInsightTitle().then((res) => {
      setInsightTitle(res?.data);
    });
  }, []);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect(); // Once it's in view, we don't need the observer anymore
        }
      });
    }, options);

    observer.observe(videoRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isInView) {
      // Simulate fetching video URL from API
      apiClient.getVideoById("hiload_home").then((res) => {
        setVideoUrl(`${res?.data[0]?.attributes?.url}`);
      });
    }
  }, [isInView]);
  const handleClose = () => setIsEnquire(false);
  const handleCloseLng = () => {
    setIsLng(false);
  };
  return (
    <>
      {isEnquire && (
        <Enquire open={isEnquire} handleClose={handleClose} small={small} />
      )}
      {/* {isLng && (
        <LanguageModel
          open={isLng}
          handleClose={handleCloseLng}
          small={small}
        />
      )} */}
      <Grid
        item
        xs={12}
        style={{
          padding: 0,
          paddingLeft: 0,
          marginTop: 71,
          position: "relative",
        }}
      >
        <Suspense
          fallback={
            <Shimmer width={small ? 800 : 1200} height={small ? 400 : 600} />
          }
        >
          <Hero
            homeSliders={homeSliders}
            launchSider={launchSider}
            imageSliders={imageSliders}
            small={small}
            medium={medium}
          />
        </Suspense>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          paddingTop: !small && 30,
          paddingLeft: 0,
          background: COLORS.lightBlack,
        }}
      >
        <SavingSection
          savingTitle={savingTitle}
          small={small}
          data={savingData}
        />
      </Grid>
      {/* <Grid
        item
        xs={12}
        style={{
          paddingTop: !small && 80,
          paddingLeft: 0,
          background: COLORS.lightBlack,
        }}
      >
        <HeroSection
          img={Banner1}
          descTitle={"Segment "}
          description={"The Euler HiLoad electric three wheeler brings you"}
          data={bannerData}
          small={small}
          medium={medium}
          color={COLORS.white}
        />
      </Grid> */}
      <Grid item xs={12} style={{ padding: 0 }}>
        {videoUrl ? (
          <VideoSection
            videoUrl={videoUrl}
            small={small}
            fromHomePage
            medium={medium}
          />
        ) : (
          <img src={VideoThumnail} alt="hiload segment video" ref={videoRef} />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          paddingTop: !small && 20,
          paddingLeft: 0,
          background: COLORS.lightBlack,
        }}
      >
        <ContactSection
          downloadBroucher={downloadBroucher}
          small={small}
          medium={medium}
        />
        <Divider
          orientation="vertical"
          flexItem
          style={{
            backgroundColor: "#3C3C3C",
            height: "0.5px", // Adjust height as needed
          }}
        />
      </Grid>
      {/*
      <Grid item xs={12}>
        <Features
          icons={icons}
          small={small}
          medium={medium}
          OBJ={specifications}
        />
      </Grid>
       */}
      {/* <Grid
        item
        xs={12}
        style={{
          background: COLORS.lightBlack,
        }}
      >
        <OurProduct small={small} data={productData} />
      </Grid> */}
      <Divider
        orientation="vertical"
        flexItem
        style={{
          backgroundColor: "#3C3C3C",
          height: "0.5px",
        }}
      />
      <Grid
        item
        xs={12}
        style={{
          background: COLORS.lightBlack,
        }}
      >
        <BlogSection ourBlogTitle={ourBlogTitle} small={small} blogs={blogs} />
      </Grid>
      <Grid item xs={12}>
        <DetailFeatureSection small={small} data={featureData} />
      </Grid>
      <Grid item xs={12}>
        <SavingsCalculator />
      </Grid>
      <Grid item xs={12}>
        <CustomerSection small={small} />
      </Grid>
      <Grid item xs={12}>
        <InsightsComponent insightTitle={insightTitle} small={small} />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          background: COLORS.lightBlack,
        }}
      >
        <Testimonials
          small={small}
          testimonials={testimonials}
          info={testimonialsInfo}
        />
      </Grid>
      {/* <Grid item xs={12}>
        <BankOffer small={small} data={bankData} />
      </Grid> */}

      <Grid
        item
        xs={12}
        style={{
          background: COLORS.lightBlack,
        }}
      >
        <Divider
          orientation="vertical"
          flexItem
          style={{
            backgroundColor: "#3C3C3C",
            height: "0.5px",
          }}
        />
        {/* <FaqComponent small={small} /> */}
      </Grid>
      {/* <Grid item xs={12}>
        <CTA
          downloadBroucher={downloadBroucher}
          small={small}
          medium={medium}
        />
      </Grid> */}
      <Grid item xs={12}>
        <BottomContent small={small} medium={medium} />
      </Grid>
      <Helmet>


        <title>
          {t(
            "Electric Loading Commercial Vehicle|3 Wheeler Electric Cargo| Euler Motors"
          )}
        </title>
        <link rel="canonical" href="https://www.eulermotors.com/en/" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/" />
        <link rel="canonical" href="https://www.eulermotors.com/te/" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/" />
        <link rel="publisher" href="https://www.eulermotors.com/" />;
        {small ? (
          <link
            rel="preload"
            href="https://euler-assets.s3.ap-south-1.amazonaws.com/slider_intro_8bac516510.webp"
            as="image"
          />
        ) : (
          <link
            rel="preload"
            href="https://euler-assets.s3.ap-south-1.amazonaws.com/slider_intro_0788c3bc39.webp"
            as="image"
          />
        )}
        <meta
          name="title"
          content={t(
            "Electric Loading Commercial Vehicle|3 Wheeler Electric Cargo| Euler Motors"
          )}
        />
        <meta
          name="description"
          content={t(
            "Experience the HiLoad EV Cargo Vehicle, most powerful electric commercial vehicle. Built to Carry Anything Anywhere. Book Now - Only for @Rs.999"
          )}
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.eulermotors.com/" />
        <meta
          property="og:title"
          content="Euler Motors | Electric Commercial Vehicle Manufacturers in India | EV Cargo Three Wheeler India"
        />
        <meta
          property="og:description"
          content="Building electric commercial three wheeler vehicle manufacturers in India. Euler HiLoad EV - The next big chapter in three wheeler electric mobility has been launched. Book Now - Only for @Rs.999."
        />
        <meta property="og:image" content={Euler} />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.eulermotors.com/" />
        <meta
          property="twitter:title"
          content="Euler Motors | Electric Commercial Vehicle Manufacturers in India | EV Cargo Three Wheeler India"
        />
        <meta
          property="twitter:description"
          content="Building electric commercial three wheeler vehicle manufacturers in India. Euler HiLoad EV - The next big chapter in three wheeler electric mobility has been launched. Book Now - Only for @Rs.999."
        />
        <meta property="twitter:image" content={Euler} />
      </Helmet>
    </>
  );
};

export default Landing;
